import React, { useState } from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";

const Input = () => {
  const [ciphertext, setCiphertext] = useState(""); 
  const [key, setKey] = useState(""); 
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCiphertext(e.target.value);
  };

  const handleKeyChange = (e) => {
    setKey(e.target.value);
  };

  const firstpage = () => {
    navigate("/");
  };

  const secondpage = () => {
    if(ciphertext.length === 0 || key.length === 0){
      alert("Please enter a valid key");
      return;
    }
    else{
    navigate("/initial", { state: { ciphertext, key } }); // Pass both ciphertext and key
    }
  };

  return (
<>
    <div className="content-box">
      <h3 className="head">What is done in this page?</h3>
      <p>In this page, the user has to enter the ciphertext and Encryption key.<br></br>
      Kindly note, the Ciphertext must be hexadecimal form and must be of length 16.<br></br>
      In the hexadecimal text you have, has length less than 16, please add zeros at appropriate place<br></br>
      Example:5 B1 EE AC 12 EE 1C 44 must be entered as <b>05</b>B1EEAC12EE1C44
      </p>
    </div>
    <div className="input-container">
      <div className="flex flex-col items-center">
        

        <div className="pt-10">
          <h1>
            Enter the Cipher text in Hex
            <br />
            (Note: Enter the cipher text obtained in experiment-2)
          </h1>
        </div>

        <div className="input-box">
          <input
            maxLength="23"
            className="border-solid border-3 bg-slate-100 px-2 py-2 rounded-md"
            type="text"
            placeholder="Enter ciphertext"
            value={ciphertext}
            onChange={handleChange}
          />
          <br />
          <br />
        </div>

        <div className="pt-10">
          <h1>
            Enter the Encryption Key
            <br />
          </h1>
        </div>

        <div className="input-box">
          <input
            maxLength="8"
            className="border-solid border-3 bg-slate-100 px-2 py-2 rounded-md"
            type="text"
            placeholder="Enter key"
            value={key}
            onChange={handleKeyChange}
          />
          <br />
          <br />
        </div>

        <div className="button-holder">
          <div className="prev-button" onClick={firstpage}>
            PREVIOUS
          </div>
          <div className="next-button" onClick={secondpage}>
            NEXT
          </div>
        </div>
      </div>
    </div></>
  );
};

export default Input;
